var React = require('react');

function Chimney (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 224H32v128h128zM32 512h288V384H32zm320 0h128V384H352zM192 224v128h288V224z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 160V32A32 32 0 0 1 32 0h448a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32z","className":"fa-primary","key":2})]);
}

Chimney.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Chimney;

Chimney.default = Chimney;
